import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Link } from '@mui/material';
import { Button, Dialog } from '@totalsoft/rocket-ui';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const CloneOfferComponent = ({
  t,
  offerHeader,
  cloneOffer,
  showInfo,
  history,
  documentId,
  siteId,
  openDuplicateConfirm,
  onChangeOpenDuplicateConfirmBool,
  isFacilityFrame,
  copyOffer
}) => {
  const getInfo = (clonedDocumentId, clonedSiteId, cloneOfferNumber, path) => ({
    identifier: `/${path}/${clonedDocumentId}/${clonedSiteId}`,
    newOfferNumber: cloneOfferNumber,
    newOfferDocumentId: clonedDocumentId,
    newOfferSiteId: clonedSiteId
  });

  const redirectToClonedOffer = info => () => {
    history.push(info.identifier);
  };

  const composeToastContent = info => {
    const documentNumber = info.newOfferNumber;
    const createdDocumentText = t('Offer.Duplication.DocumentCreated', { documentNumber });
    const parts = createdDocumentText.split(documentNumber);
    const createdDocumentLink = (
      <Link component='button' underline='hover' onClick={redirectToClonedOffer(info)}>
        {documentNumber}
      </Link>
    );

    const toastContent = (
      <div>
        {parts[0]}
        {createdDocumentLink}
        {parts[1]}
      </div>
    );

    return toastContent;
  };

  const cloneFacility = async () => {
    onChangeOpenDuplicateConfirmBool(false);
    const event = await cloneOffer(documentId, siteId, offerHeader.offerNumber);
    if (event.ok) {
      const info = getInfo(event.eventBody.cloneDocumentId, event.eventBody.cloneSiteId, event.eventBody.cloneOfferNumber, 'offers');
      const toastContent = composeToastContent(info);
      showInfo(toastContent, false);
    }
  };

  const cloneLeasingOffer = async () => {
    onChangeOpenDuplicateConfirmBool(false);
    const event = await copyOffer(documentId, siteId);
    if (event.ok) {
      const info = getInfo(event.eventBody.documentId, event.eventBody.siteId, event.eventBody.offerNumber, 'offers');

      const toastContent = composeToastContent(info);
      showInfo(toastContent, false);
    }
  };

  const handleClose = () => {
    onChangeOpenDuplicateConfirmBool(false);
  };

  return (
    <Dialog
      open={openDuplicateConfirm}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      title={t('OfferEdit.Dialog.ConfirmDuplicateTitle')}
      content={t('OfferEdit.Dialog.ConfirmDuplicateDescription', { data: offerHeader })}
      actions={
        <BoxActionsWrapper forDialog>
          <Button id={'offerDuplicate_dialog_acceptBtn'} autoFocus onClick={isFacilityFrame ? cloneFacility : cloneLeasingOffer}>
            {t('OfferEdit.Client.Dialog.AcceptButton')}
          </Button>
          <Button id={'offerDuplicate_dialog_rejectBtn'} variant='outlined' onClick={handleClose}>
            {t('OfferEdit.Client.Dialog.RejectButton')}
          </Button>
        </BoxActionsWrapper>
      }
    />
  );
};

CloneOfferComponent.propTypes = {
  t: PropTypes.func.isRequired,
  offerHeader: PropTypes.object.isRequired,
  cloneOffer: PropTypes.func.isRequired,
  showInfo: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  openDuplicateConfirm: PropTypes.bool.isRequired,
  onChangeOpenDuplicateConfirmBool: PropTypes.func.isRequired,
  isFacilityFrame: PropTypes.bool,
  copyOffer: PropTypes.func.isRequired
};

export default compose(withTranslation())(CloneOfferComponent);
